import { Field } from "react-final-form";
import { LabSelector } from "../../../components/inputs/LabSelector";
import { Card, FormText } from "reactstrap";
import { LoadingButton } from "../../../components/LoadingButton";
import { SerializedLabSelector } from "../../../components/inputs/final_form/LabSelector";
import { TestSelector } from "../../../components/inputs/final_form/TestSelector";
import { SerializedPayorSelector } from "../../../components/inputs/final_form/PayorSelector";
import { SelectInput } from "../../../components/inputs/final_form/SelectInput";
import { AdministrateSelectInput, AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";
import { required } from "../../../util/validators";
import { useMemo } from "react";

const caseTypeOptions = [
  { label: "Lab", value: "lab" },
  { label: "Pharmacy", value: "pharmacy" },
];

const labToOption = (lab) => (lab ? [{ label: lab.labName, value: lab.id }] : []);

export const SpecialProjectCaseAssignmentForm = ({ form, handleSubmit, submitting, initialValues, values, ...rest }) => {
  const initialLabOptions = useMemo(() => labToOption(initialValues.lab), [initialValues]);
  const selectedLabId = values?.labId ? [values?.labId] : [];

  const initialTestOptions = useMemo(() => {
    return initialValues.tests ? initialValues.tests.map((test) => ({ label: test.commercial_name, value: test.id })) : [];
  }, [initialValues.tests]);

  const initialPayorOptions = useMemo(() => {
    return initialValues.payors ? initialValues.payors.map((payor) => ({ label: payor.name, value: payor.id })) : [];
  }, [initialValues.payors]);

  const initialAccountOptions = useMemo(() => {
    return initialValues.accounts
      ? initialValues.accounts.map((account) => ({ label: account.full_name_or_email, value: account.id }))
      : [];
  }, [initialValues.accounts]);

  return (
    <>
      <Field
        initialOptions={initialPayorOptions}
        component={AdminOptionableInput}
        resource="payors"
        searchParam="name"
        label="Payors"
        kept={true}
        isMulti
        name="payorIds"
      />

      <Field initialOptions={initialLabOptions} label="Lab" component={SerializedLabSelector} name="labId" valueKey="id" />

      <Field
        initialOptions={initialTestOptions}
        label="Tests"
        component={TestSelector}
        labIds={selectedLabId}
        name="testIds"
        isMulti
        placeholder="Select one or more Tests..."
        disabled={values.labId ? false : true}
      >
        {selectedLabId.length === 0 && <FormText>Choose a Lab to enable the Test field.</FormText>}
      </Field>

      <Field
        label="Case Type"
        component={SelectInput}
        name="servicingProviderType"
        options={caseTypeOptions}
        validate={required}
        required
      />

      <Field
        initialOptions={initialAccountOptions}
        component={AdministrateSelectInput}
        resourceUrl="/admin/accounts.json"
        label="Users"
        name="accountIds"
        labelKey="full_name_or_email"
        isMulti
      />

      <LoadingButton loading={submitting} onClick={handleSubmit}>
        Submit
      </LoadingButton>
    </>
  );
};
